
        var i18n = require('cadenza/utils/i18n/i18n');
        module.exports = (function () {
          var messages = {"de":{"furtherActions":"~Mehr {{attributeName}} Aktionen...","information":"~Informationen für {{attributeName}} Attribut","remove":"~Entfernen {{attributeName}} Attribut","error":"~Fehler auf {{attributeName}} Attribut"},"en":{"furtherActions":"~More {{attributeName}} actions  ...","information":"~Information for {{attributeName}} attribute","remove":"~Remove {{attributeName}} attribute","error":"~Error on {{attributeName}}"}};
          return function () {
            return i18n.loaderI18n.apply(messages[window.Disy.language], arguments);
          };
        })();